import {Pipe, PipeTransform} from '@angular/core';
import {SortDirection, TableSort} from '../shared/classes/TableSort';

/**
 * This pipe handles sorting the list.
 */
@Pipe({
  name: 'listSort',
})
export class ListSortPipe implements PipeTransform {

  /**
   * Sorts the list by the given column in the given direction.
   * @param list the list to be sorted.
   * @param tableSort table column and its direction for sorting.
   */
  transform(list: any[], tableSort: TableSort): any {
    if (!tableSort || tableSort.direction === SortDirection.NONE) {
      return list;
    }
    return [...list].sort((first, second) => {
      const result = compare(first[tableSort.column], second[tableSort.column]);
      return tableSort.direction === SortDirection.ASC ? result : -result;
    });
  }
}

const compare = (v1, v2) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
